import React, { useEffect, useState } from 'react';
import { Typography, Breadcrumb, Card, Descriptions, Tag, Space, Button, Popconfirm, message, Alert } from 'antd';

const { Title, Paragraph } = Typography;

const AgencyActions = () => {
  const [loading, setLoading] = useState(false);
  const [agency, setAgency] = useState(null);
  const [isSuspended, setIsSuspended] = useState(false);
  const [deleted, setDeleted] = useState(false);

  useEffect(() => {
    // TODO: Replace with real API to fetch agency
    setLoading(true);
    const timer = setTimeout(() => {
      const mock = {
        id: 1,
        name: 'Acme Media',
        email: 'contact@acme.com',
        status: 'active',
        created_at: '2025-01-15',
      };
      setAgency(mock);
      setIsSuspended(mock.status === 'suspended');
      setLoading(false);
    }, 400);
    return () => clearTimeout(timer);
  }, []);

  const confirmSuspend = () => {
    // TODO: Call backend to suspend
    setIsSuspended(true);
    message.success('Agency has been suspended.');
  };

  const confirmUnsuspend = () => {
    // TODO: Call backend to unsuspend
    setIsSuspended(false);
    message.success('Agency has been reactivated.');
  };

  const confirmDelete = () => {
    // TODO: Call backend to delete (ensure backend enforces referential checks)
    setDeleted(true);
    message.success('Agency account deleted.');
  };

  if (deleted) {
    return (
      <div style={{ padding: 24 }}>
        <Breadcrumb items={[
          { title: 'Admin' },
          { title: 'Agencies' },
          { title: 'Suspend/Delete Account' },
        ]} />
        <Card>
          <Alert type="success" showIcon message="Agency account has been deleted" description="This is a placeholder state. In production, redirect back to the agencies list." />
        </Card>
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[
        { title: 'Admin' },
        { title: 'Agencies' },
        { title: 'Suspend/Delete Account' },
      ]} />

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Suspend/Delete Account</Title>
      </div>

      <Card loading={loading} title="Agency">
        {agency && (
          <Descriptions bordered column={2} size="middle">
            <Descriptions.Item label="ID">{agency.id}</Descriptions.Item>
            <Descriptions.Item label="Name">{agency.name}</Descriptions.Item>
            <Descriptions.Item label="Email">{agency.email}</Descriptions.Item>
            <Descriptions.Item label="Status">
              <Tag color={isSuspended ? 'orange' : 'green'}>
                {isSuspended ? 'suspended' : 'active'}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Created">{agency.created_at}</Descriptions.Item>
          </Descriptions>
        )}

        <Paragraph type="secondary" style={{ marginTop: 12 }}>
          These actions are sensitive. Ensure you have proper confirmation and audit logs on the backend.
        </Paragraph>

        <Space size="middle" style={{ marginTop: 16 }}>
          {!isSuspended ? (
            <Popconfirm
              title="Suspend this agency?"
              description="Users under this agency will be prevented from logging in until reactivated."
              okText="Suspend"
              onConfirm={confirmSuspend}
            >
              <Button type="default" danger> Suspend </Button>
            </Popconfirm>
          ) : (
            <Popconfirm
              title="Reactivate this agency?"
              okText="Reactivate"
              onConfirm={confirmUnsuspend}
            >
              <Button type="primary"> Reactivate </Button>
            </Popconfirm>
          )}

          <Popconfirm
            title="Delete this agency?"
            description="This action is permanent. Ensure the agency has no dependent records (vehicles, trips, campaigns, etc.)."
            okText="Delete"
            okButtonProps={{ danger: true }}
            onConfirm={confirmDelete}
          >
            <Button danger> Delete Account </Button>
          </Popconfirm>
        </Space>
      </Card>
    </div>
  );
};

export default AgencyActions;
